import leadSourceFields from './lead-sources';

export default {
    customFields: [
        {resource: 'transactions', path: 'customFields'},
        {resource: 'customers', path: 'customer/customFields'},
        {resource: 'payment-cards', path: 'paymentCard/customFields'},
    ],
    fields: [
        {field: 'id', isDefault: true},
        {field: 'customerId', isDefault: true},
        {field: 'websiteId', isDefault: false},
        {field: 'websiteName', isDefault: false},
        {field: 'parentTransactionId', isDefault: false},
        {field: 'invoiceIds', isDefault: false},
        {field: 'subscriptionId', isDefault: false},
        {field: 'planIds', isDefault: false},
        {field: 'gatewayAccountId', isDefault: false},
        {field: 'gatewayTransactionId', isDefault: false},
        {field: 'paymentCardId', isDefault: false},
        {field: 'currency', isDefault: true},
        {field: 'type', isDefault: true},
        {field: 'result', isDefault: true},
        {field: 'status', isDefault: false},
        {field: 'gatewayName', isDefault: false},
        {field: 'acquirerName', isDefault: false},
        {field: 'amount', isDefault: true},
        {field: 'rebillNumber', isDefault: false},
        {field: 'method', isDefault: false},
        {field: 'createdTime', isDefault: false},
        {field: 'updatedTime', isDefault: false},
        {field: 'hasDcc', isDefault: false},
        {field: 'bin', isDefault: false},
        {field: 'riskScore', isDefault: false},
        {field: 'velocity', isDefault: false},
        {field: 'revision', isDefault: false},
        {field: 'has3ds', isDefault: false},
        {field: 'retryNumber', isDefault: false},
        {field: 'isRebill', isDefault: false},
        {field: 'scheduledTime', isDefault: false},
        {field: 'processedTime', isDefault: true},
        {field: 'retriedTransactionId', isDefault: false},
        {field: 'description', isDefault: false},
        {field: 'billingAddress/firstName', isDefault: false},
        {field: 'billingAddress/lastName', isDefault: false},
        {field: 'billingAddress/address', isDefault: false},
        {field: 'billingAddress/address2', isDefault: false},
        {field: 'billingAddress/organization', isDefault: false},
        {field: 'billingAddress/city', isDefault: false},
        {field: 'billingAddress/region', isDefault: false},
        {field: 'billingAddress/country', isDefault: false},
        {field: 'billingAddress/postalCode', isDefault: false},
        {field: 'billingAddress/email', isDefault: false},
        {field: 'billingAddress/phoneNumber', isDefault: false},
        {field: 'riskMetadata/ipAddress', isDefault: false},
        {field: 'riskMetadata/isVpn', isDefault: false},
        {field: 'riskMetadata/isProxy', isDefault: false},
        {field: 'riskMetadata/isTor', isDefault: false},
        {field: 'riskMetadata/isHosting', isDefault: false},
        {field: 'riskMetadata/isp', isDefault: false},
        {field: 'riskMetadata/vpnServiceName', isDefault: false},
        {field: 'riskMetadata/score', isDefault: false},
        {field: 'riskMetadata/fingerprint', isDefault: false},
        {field: 'riskMetadata/country', isDefault: false},
        {field: 'riskMetadata/city', isDefault: false},
        {field: 'riskMetadata/latitude', isDefault: false},
        {field: 'riskMetadata/longitude', isDefault: false},
        {field: 'riskMetadata/accuracyRadius', isDefault: false},
        {field: 'riskMetadata/postalCode', isDefault: false},
        {field: 'riskMetadata/timeZone', isDefault: false},
        {field: 'riskMetadata/distance', isDefault: false},
        {field: 'isDisputed', isDefault: false},
        {field: 'isRetry', isDefault: false},
        {field: 'retriesResult', isDefault: false},
        {field: 'gatewayResponseMessage', isDefault: false},
        {field: 'gatewayResponseOriginalMessage', isDefault: false},
        {field: 'gatewayResponseCode', isDefault: false},
        {field: 'baseAmount', isDefault: false},
        {field: 'baseCurrency', isDefault: false},
        {field: 'dccUsdMarkup', isDefault: false},
        {field: 'organizationId', isDefault: false},
        {field: 'isReconciled', isDefault: false},
        {field: 'hadDiscrepancy', isDefault: false},
        {field: 'orderId', isDefault: false},
        {field: 'hasBumpOffer', isDefault: false},
        {field: 'bumpOffer/outcome', isDefault: false},
        {field: 'bumpOffer/currency', isDefault: false},
        {field: 'bumpOffer/orderAmount', isDefault: false},
        {field: 'bumpOffer/bumpAmount', isDefault: false},
        {field: 'bumpOffer/bonusAmount', isDefault: false},
        {field: 'bumpOffer/orderAmountInUsd', isDefault: false},
        {field: 'bumpOffer/bumpAmountInUsd', isDefault: false},
        {field: 'bumpOffer/bonusAmountInUsd', isDefault: false},
        {field: 'billingDescriptor', isDefault: false},
        {field: 'isProcessedOutside', isDefault: false},
    ].concat(leadSourceFields),
};
